export default {"src":"/_next/static/media/arrow-up.c838f8dd.svg","height":513,"width":513};